import { jsx } from "panel";
import { ModalEl } from "common/components/modal";
import { SvgIconEl } from "common/components/svg-icon";
export function template() {
  const {
    orgs,
    submitted
  } = this.state;
  return /* @__PURE__ */ jsx("div", { sel: ".select-org-modal-container", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(ModalEl, { sel: ".select-org-modal", attrs: {
    closeable: this.attr(`show-cancel`),
    open: this.attr(`open`) && !submitted
  }, on: {
    submit: this.helpers.handleSubmit
  }, "data-sentry-element": "ModalEl", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-card-header" }, /* @__PURE__ */ jsx("div", { sel: ".mp-card-header-title" }, this.attr(`title-text`))), /* @__PURE__ */ jsx("div", { sel: ".action-text" }, "Select Organization"), /* @__PURE__ */ jsx("div", { sel: ".input-area" }, orgs ? orgs.map((org) => /* @__PURE__ */ jsx("div", { sel: ".org-card", on: {
    click: () => this.helpers.selectOrg(org)
  } }, /* @__PURE__ */ jsx("div", { sel: ".org-card-container" }, /* @__PURE__ */ jsx("div", { sel: ".org-name" }, org.name), /* @__PURE__ */ jsx("div", { sel: ".caret-icon" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: `caret-right`
  } }))))) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-small" }), /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-small" }), /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-small" }), /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-small" })))));
}
